import { getTranslationFor } from '@/text/translations';
import ApplicationButton from '@/components/ApplicationButton/ApplicationButton';
import styles from './IntegrationSteps.module.css';

const steps = [
  { number: 1, titleKey: 'integrationGuide.step1.title' as const, descriptionKey: 'integrationGuide.step1.description' as const, hasButton: true },
  { number: 2, titleKey: 'integrationGuide.step2.title' as const, descriptionKey: 'integrationGuide.step2.description' as const },
  { number: 3, titleKey: 'integrationGuide.step3.title' as const, descriptionKey: 'integrationGuide.step3.description' as const },
  { number: 4, titleKey: 'integrationGuide.step4.title' as const, descriptionKey: 'integrationGuide.step4.description' as const },
  { number: 5, titleKey: 'integrationGuide.step5.title' as const, descriptionKey: 'integrationGuide.step5.description' as const },
  { number: 6, titleKey: 'integrationGuide.step6.title' as const, descriptionKey: 'integrationGuide.step6.description' as const },
];

export default function IntegrationSteps() {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>{getTranslationFor('integrationGuide.title')}</h2>
        <ol className={styles.steps}>
          {steps.map((step) => (
            <li key={step.number} className={styles.step}>
              <div className={styles.stepNumber} aria-hidden="true">{step.number}</div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>{getTranslationFor(step.titleKey)}</h3>
                <p className={styles.stepDescription}>{getTranslationFor(step.descriptionKey)}</p>
                {step.hasButton && (
                  <ApplicationButton className={styles.stepButton}>
                    {getTranslationFor('integrationGuide.step1.button')}
                  </ApplicationButton>
                )}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
